/**
 * This script adds some additional methods to window.location
 *  buildQuery      Helper method for constricting query strings
 *  query           location.query manipulator
 *  hashQuery       location.hash manipulator
 */

const location = window.location;

export function buildUrl(pathname, queryString) {
	if (!queryString) {
		return pathname;
	}
	queryString = '' + queryString;
	if (!queryString.startsWith('?')) {
		queryString = '?' + queryString;
	}
	return pathname + queryString;
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @param {boolean} [numeric_prefix]
 * @return {string}
 */
export function buildQuery(queryData, numeric_prefix) {
	let value, key, tmp = [];
	const arg_separator = "&";

	for (key in queryData) {
		if (!queryData.hasOwnProperty(key)) {
			continue;
		}
		value = queryData[key];
		if (numeric_prefix && !isNaN(key)) {
			key = String(numeric_prefix) + key;
		}
		const query = http_build_query_helper(urlencode(key), value, arg_separator);
		if (query !== '') {
			tmp.push(query);
		}
	}

	return tmp.join(arg_separator);
}

/**
 * Appends given query data to given URL
 * @param {string} url
 * @param {object} queryData
 * @return {string} New url
 */
export function addQuery(url, queryData) {
	const q = buildQuery(queryData);
	url = '' + url;
	const m = /^([^?#]*)(\?[^#]+)?(#.+)?$/.exec(url);
	if (!m) {
		return url + '?' + q;
	}
	return (m[1] || '') + (m[2] ? m[2] + '&' + q : '?' + q) + (m[3] || '');
}

/**
 * Appends given query data to given query string
 * @param {string} queryString
 * @param {object} queryData
 * @return {string} New query string
 */
export function appendQuery(queryString, queryData) {
	const q = buildQuery(queryData);
	if (!q) {
		return queryString;
	}
	const str = '' + queryString;
	return str.length > 0 ? str + '&' + q : q;
}

/**
 * Manipulates <code>location.search</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.search</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.search</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.search</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
export function query(key, value, extend) {
	return processQuery('search', key, value, extend);
}

/**
 * Manipulates <code>location.hash</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.hash</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.hash</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.hash</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
export function hashQuery(key, value, extend) {
	return processQuery('hash', key, value, extend);
}

function processQuery(type, key, value, extend) {
	let queryData = decodeQueryString(location[type].substring(1));
	if (key !== undefined) {
		const isObj = typeof key === 'object';

		if (value === undefined && !isObj) {
			// return value
			return queryData[key] === undefined ? null : queryData[key];
		} else if (!isObj) {
			if (extend === undefined) extend = true;

			// set value to key
			const k = key.toString();
			key = {};
			key[k] = value;
		}

		if (extend) {
			$.extend(queryData, key);
		} else {
			queryData = key;
		}

		// clear data
		const newData = {};
		$.each(queryData, function (key, value) {
			if (value) newData[key] = value;
		});
		queryData = newData;

		location[type] = buildQuery(queryData);
	}
	return queryData;
}

/**
 * Decodes query string like 'a=one&b=two&c[]=three' and returns an object
 * @param string
 * @return {Object}
 */
export function decodeQueryString(string) {
	let glue1 = '=',
		glue2 = '&',
		array = {}, // holds result
		array2 = String(string).replace(/^&?([\s\S]*?)&?$/, '$1').split(glue2),
		i, j, chr, tmp, key, value, bracket, keys, evalStr,
		fixStr = function (str) {
			return decodeURIComponent(str).replace(/([\\"'])/g, '\\$1').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\+/g, ' ');
		};

	for (i = 0; i < array2.length; i++) {
		tmp = array2[i].split(glue1);
		if (tmp.length < 2) {
			tmp = [tmp, ''];
		}
		key = fixStr(tmp[0]);
		value = fixStr(tmp[1]);
		while (key.charAt(0) === ' ') {
			key = key.substr(1);
		}
		if (key.indexOf('\0') !== -1) {
			key = key.substr(0, key.indexOf('\0'));
		}
		if (key && key.charAt(0) !== '[') {
			keys = [];
			bracket = 0;
			for (j = 0; j < key.length; j++) {
				if (key.charAt(j) === '[' && !bracket) {
					bracket = j + 1;
				} else if (key.charAt(j) === ']') {
					if (bracket) {
						if (!keys.length) {
							keys.push(key.substr(0, bracket - 1));
						}
						keys.push(key.substr(bracket, j - bracket));
						bracket = 0;
						if (key.charAt(j + 1) !== '[') {
							break;
						}
					}
				}
			}
			if (!keys.length) {
				keys = [key];
			}
			for (j = 0; j < keys[0].length; j++) {
				chr = keys[0].charAt(j);
				if (chr === ' ' || chr === '.' || chr === '[') {
					keys[0] = keys[0].substr(0, j) + '_' + keys[0].substr(j + 1);
				}
				if (chr === '[') {
					break;
				}
			}
			evalStr = 'array';
			for (j = 0; j < keys.length; j++) {
				key = keys[j];
				if ((key !== '' && key !== ' ') || j === 0) {
					key = "'" + key + "'";
				} else {
					key = eval(evalStr + '.push([]);') - 1;
				}
				evalStr += '[' + key + ']';
				if (j !== keys.length - 1 && eval('typeof ' + evalStr) === 'undefined') {
					eval(evalStr + ' = [];');
				}
			}
			evalStr += " = '" + value + "';\n";
			eval(evalStr);
		}
	}

	return array;
}

function urlencode(str) {
	str = (str + '').toString();
	return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

function http_build_query_helper(key, val, arg_separator) {
	let k, tmp = [];
	if (val === true) {
		val = "1";
	} else if (val === false) {
		val = "0";
	}
	if (val !== null && val !== undefined && val !== '') {
		if (typeof(val) === "object") {
			let start = 0;
			for (k in val) {
				if (!val.hasOwnProperty(k)) {
					continue;
				}
				if (val[k] !== null) {
					let sk, num = Number(k);
					if (!isNaN(num) && num - start === 0) {
						if (typeof(val[k]) === "object") {
							sk = num;
						} else {
							sk = '';
						}
						start++;
					} else {
						sk = urlencode(k);
					}
					const part = http_build_query_helper(key + "[" + sk + "]", val[k], arg_separator);
					if (part) {
						tmp.push(part);
					}
				}
			}
			return tmp.join(arg_separator);
		} else if (typeof(val) !== "function") {
			return key + "=" + urlencode(val);
		} else {
			throw new Error('There was an error processing for http_build_query().');
		}
	} else {
		return '';
	}
}



// WEBPACK FOOTER //
// ./core/utils/location.js